import { AncillariesInt, ExtrasBagsAncillarieInt } from "@app/interfaces";

export class AncillariesMapper {
  constructor() { }

  static getAncillaries(res: AncillariesInt) {
    const ancillaries = res._collection?.length > 0 ? res._collection[0] : undefined;
    let response: ExtrasBagsAncillarieInt = {};
    if (ancillaries) {
      const { extraBags, extraBags20KG, extraWeight, carryOn } = ancillaries;
      response.carryOn = carryOn._collection//Object.getOwnPropertyNames(carryOn._collection).map(x=> {return carryOn?._collection[x]})
      response.extraBags = Object.getOwnPropertyNames(extraBags._collection).map(x => { return extraBags?._collection[x] })
      response.extraBags20KG = Object.getOwnPropertyNames(extraBags20KG._collection).map(x => { return extraBags20KG?._collection[x] })
      response.extraWeight = Object.getOwnPropertyNames(extraWeight._collection).map(x => { return extraWeight?._collection[x] })
      // CI-21979: lógica histórica deshabilitada (no se ejecuta). Se conserva como
      // referencia; el precio de extra weight proviene del backend (línea anterior).
      // response.extraWeight = this.customExtraWeigth(
      //   reservation,
      //   response.extraWeight
      // );
    }
    return response;
  }

  // CI-21979: método histórico deshabilitado (no ejecutable). Se conserva como
  // referencia. Antes sobrescribía el precio de extra weight con valores
  // hardcodeados; ahora se usa el precio real recibido del backend.
  // private static customExtraWeigth(reservation: Reservation, extrasWeight) {
  //   for (let extraWeight of extrasWeight) {
  //     if (reservation.flightSummary.isDomestic) {
  //       if (extraWeight?.type === "0C6") {
  //         extraWeight.currency.total = 700;
  //       } else if (extraWeight?.type === "OW2") {
  //         extraWeight.currency.total = 700;
  //       } else if (extraWeight?.type) {
  //         extraWeight.currency.total = 1300;
  //       }
  //     } else {
  //       if (extraWeight?.type === "0C6") {
  //         extraWeight.currency.total = 1800;
  //       } else if (extraWeight?.type === "OW2") {
  //         extraWeight.currency.total = 700;
  //       } else if (extraWeight?.type) {
  //         extraWeight.currency.total = 3600;
  //       }
  //     }
  //   }
  //   return extrasWeight;
  // }
}
